var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinnerCoverImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 691.57 197.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#a3cfd9;}.cls-1{opacity:0.61;}.cls-3{fill:#fff;}.cls-4{fill:#338598;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "334.15 97.34 3.27 182.81 3.27 97.34 334.15 97.34"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 340.78,
    y: -260.17,
    width: 10,
    height: 712.85,
    transform: "translate(164.05 405.78) rotate(-75.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -9.83,
    y: 92.09,
    width: 708.06,
    height: 10,
    transform: "translate(-13.39 91.95) rotate(-14.93)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "130.84 118.79 131.04 140.43 124.03 136.31 119.71 141.25 131.46 155.06 136.2 163.1 153.92 162.69 159.28 152.38 156.81 136.51 139.49 133.22 138.67 116.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.71,152a2.13,2.13,0,0,0,.15-.79v-7.28a6.4,6.4,0,0,0-5-6.27l-14.23-3.16V119.94a2.14,2.14,0,0,0-4.27,0v26.53l-6.83-6.85a2.4,2.4,0,0,0-3.39,3.39l9.12,9.12a6.08,6.08,0,0,1,1.2,1.64l3.37,6.74h16.47Zm-27.62-32a6.41,6.41,0,0,1,12.82,0h0v11.11l10.86,2.41a10.7,10.7,0,0,1,8.37,10.43v7.28a6.71,6.71,0,0,1-.46,2.38l-4.51,11.26h-22l-4.53-9.13a2.36,2.36,0,0,0-.4-.54L120.1,146a6.67,6.67,0,0,1,9-9.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M347.16,28.69c6,0,10.32-4.68,10.32-11.12S353.14,6.46,347.16,6.46s-10.32,4.67-10.32,11.11S341.18,28.69,347.16,28.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M333.9,40.89v69.53a3.93,3.93,0,1,0,7.85,0V75.11a4.91,4.91,0,0,1,9.81,0v35.31a3.92,3.92,0,1,0,7.84,0V41.35c11.61-4.86,19-16.8,19-32.28a3.93,3.93,0,0,0-7.85,0c0,16-9.4,26.81-23.4,26.81s-23.4-10.77-23.4-26.81a3.92,3.92,0,0,0-7.84,0c0,15,7,26.7,18,31.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M402.09,67.94c6,0,10.31-4.67,10.31-11.11s-4.33-11.12-10.31-11.12-10.32,4.68-10.32,11.12,4.34,11.11,10.32,11.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M392.75,153.6a3.92,3.92,0,0,0,3.92-3.92V114.37a4.91,4.91,0,0,1,9.81,0v35.31a3.93,3.93,0,0,0,7.85,0V79.06a3.92,3.92,0,0,0-3.93-3.92H392.75a3.93,3.93,0,0,0-3.92,3.92v70.62a3.91,3.91,0,0,0,3.92,3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M418.91,165.38H371.57V130.05a3.92,3.92,0,0,0-3.92-3.92h-41a3.91,3.91,0,0,0-3.92,3.92V152.3h-50a3.93,3.93,0,0,0-3.92,3.92v37.33a3.93,3.93,0,0,0,3.92,3.92H418.91a3.92,3.92,0,0,0,3.92-3.92V169.31a3.93,3.93,0,0,0-3.93-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M292.4,59.8c6,0,10.31-4.68,10.31-11.12s-4.33-11.11-10.31-11.11-10.32,4.67-10.32,11.11S286.42,59.8,292.4,59.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M283.06,145.46a3.92,3.92,0,0,0,3.92-3.93v-35.3a4.91,4.91,0,0,1,9.81,0v35.3a3.93,3.93,0,1,0,7.85,0V70.92A3.92,3.92,0,0,0,300.72,67H283.06a3.93,3.93,0,0,0-3.92,3.92v70.62a3.92,3.92,0,0,0,3.92,3.92Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinnerCoverImage);
export default __webpack_public_path__ + "static/media/Winner-cover-image.0a119180bde8d2cf7444afc9d7d8e626.svg";
export { ForwardRef as ReactComponent };